const mainSocketURL = process.env.REACT_APP_SOCKET_URL;
export const dataConstants = {
  socketURL: `${mainSocketURL}/auctions`,

  //Auth URLs
  loginUrl: `/login`,
  logoutUrl: `/logout`,
  refreshTokenUrl: `/refresh`,
  checkSessionUrl: `/session_active_check`,
  removeTokenUrl: `/remove_token`,
  forgotPasswordUrl: `/forgotpassword`,
  changePasswordUrl: `/changepassword`,
  resetPasswordUrl: `/resetpassword`,
  userDevicesUrl: `/user_devices`,
  getIframeData: `/get_iframe_data`,

  //Common URLs
  getBranchesUrl: `/branches`,
  getSeasonUrl: `/get_season_date_map`,
  getHubsUrl: `/hubs`,
  getVarietiesUrl: `/varieties`,
  getCropsUrl: `/crop`,
  getBagTypeListUrl: `/bag_type`,
  getSlotIdsUrl: `/branchslots`,
  getTCUrl: `/termscondition`,
  getPrivacyPolicyUrl: `/privacypolicy`,
  getRebateMatrixUrl: `/rebatematrix`,

  //Auction URLs
  getActiveAuctionsUrl: `/active_auctions`,
  getActiveBidsUrl: `/supplieractivebids`,
  // getOrderDetailsUrl: `/get_order_details_by_saudha`,
  getOrderDetailsUrl: `/get_order_details_by_po`,
  exportOrderDetailsUrl: `/export_my_orders`,
  postBidUrl: `/submitbid`,
  postTCUrl: `/auction_agreement`,
  updateRebateUrl: `/rebate_agreement`,
  getLowestBidUrl: `/getlowestbid`,

  //myBids
  getMyBidsUrl: `/viewsupplierbids`,
  //Archive auction
  getArchivesUrl: `/supplierarchive`,
  //Upcoming auction
  getUpcomingAuctionUrl: `/supplierupcoming`,
  //My Wins
  getWinsUrl: `/my_wins`,
  //sockets endpoints
  getSocketActiveAuction: `/auctions`,
  getSocketUpcomingAuction: `/upcoming_auctions`,
  getSocketMyWinsAuction: `/mywins_auctions`,
  getVendoeDetailsUrl: `/get_vendor_details`,
  checkPANUrl: "/verify_pan_no",
  postRegisterUrl: `/vendor_details`,
  generateOtp: "/generate_otp",
  verifyOtp: "/verify_otp",
  getRegBranchesUrl: `/reg_branches`,
  getRegCropUrl: `/reg_crop`,
  checkAvailabilityUrl: `/check_username_availability`,
  checkRefundAvailabilityUrl: `/check_refund_applicable`,
  putRefundREquestUrl: `/apply_refund_requests`,
  getRefundHistoryUrl: `/user_refund_trail`,

  //my profile
  getUserDetailsUrl: `/getuser_data`,
  postUserDetailsUrl: `/user_data`,
  postPhotoSasUrl: `/generate_profile_photo_sas`,

  //payment GateWay
  getOrderIdDetailsUrl: `/oderdetails`,
  customerDetails: `/customerdetails`,
  getParameterUrl: `/getparameter`,
  getTradingLimitUrl: `/trade_limit`,
  getOrderIDUrl: `/orders`,
  paymentUpdateDetailsUrl: `/payment_order_update`,
};

export const claimList = [
  { id: 1, name: "Claim" },
  { id: 2, name: "No Claim" },
];

export const deliveryStatusList = [
  { id: "Pending", name: "Pending" },
  { id: "Delivered", name: "Delivered" },
];

export const paymentStatusList = [
  { id: "Pending", name: "Pending" },
  { id: "Paid", name: "Paid" },
];

export const saudaTypeList = [
  { id: "Tradenext", name: "Tradenext" },
  { id: "Offline Saudha", name: "Offline Saudha" },
  { id: "Pending", name: "Pending" },
];
export const auctionTypeList = [
  { id: 1, name: "Normal" },
  { id: 2, name: "Rake Sauda" },
];

export const poStatusList = [
  { id: "Open", name: "Open" },
  { id: "Closed", name: "Closed" },
  { id: "Short Closed", name: "Short Closed" },
  { id: "Force Closed", name: "Force Closed" },
  { id: "Approval Pending", name: "Approval Pending" },
  { id: "CRN in process", name: "CRN in process" },
];

export const sleepTimer: number = 180000;
